import styled from "styled-components";
import { cloud } from "@vitalsource/vstui/colors";
import { styledMedia } from "../../../components/mediaquery/breakpoints";
import React from "react";
import { actions as modalActions } from "../../../../redux/modals";
import { goToStore } from "../../../../redux/navigation/actions";
import { connect } from "react-redux";
import { t } from "../../../core/translate";
import { Button } from "@vitalsource/vstui";
import RedeemCodes from "../../../components/icons/RedeemCodes";
import StoreCart from "../../../components/icons/StoreCart";
import { getBrandedStoreUrl } from "../../../../redux/brand/selectors";
import { store } from "../../../../redux/store";

const BottomContent = styled.div`
  padding: 0 25px;
  justify-content: center;
  display: flex;
  flex-direction: row;

  h3 {
    font-size: 2.4rem;
    font-weight: 500;
    color: ${cloud.getShade(10)};
    margin-top: 15px;
  }
  p {
    color: ${cloud.getShade(10)};
    font-size: 1.6rem;
    font-weight: 400;
    margin: 15px 0;
  }
  svg {
    float: left;
  }
  ${styledMedia.medium`
    padding: 0px;
  `}
  ${styledMedia.small`
    flex-direction: column;
    padding: 0;
    text-align: center;
    display: block;
    svg {
      float: none;
    }
  `}
`;

const ActionBlock = styled.div`
  margin: 0 50px;
  &.null-redeem-block {
    margin-bottom: 50px;
  }
  ${styledMedia.medium`
    margin: 0 25px 0 25px;
  `}
  ${styledMedia.small`
    margin: 0 ;
    width: 100%;
  `}
`;

const BottomContentTextBlocks = styled.div`
  min-width: 315px;
  ${styledMedia.small`
    width: 100%;
    padding: 5px 25px;
    display: flex;
    flex-direction: column;
    align-items: center;
  `}
  ${styledMedia.medium`
    text-align: center;
  `}
`;

const SvgContainer = styled.div`
  height: 165px;
  float: left;
  svg {
    width: 182px;
    height: 164px;
    margin-right: 2em;
  }
  ${styledMedia.small`
    float: none;
    width: 100%;
    svg {
      margin: 0;
    }
  `}
  ${styledMedia.medium`
    float: none;
    justify-content: center;
    display: flex;
    svg {
      margin: 0;
    }
  `}
`;

const renderShopBlock = goToStore => {
  if (Fraction.Brand.Store.visible && Fraction.Brand.Store.shopNow) {
    const storeUrl = getBrandedStoreUrl(store.getState(), {
      utm_medium: "bookshelf-library-shop"
    });
    return (
      <ActionBlock>
        <SvgContainer>
          <StoreCart />
        </SvgContainer>
        <BottomContentTextBlocks>
          <h3>{t("global-bar.shop-now", "Shop Now")}</h3>
          <p>
            {t(
              "library.visit-store",
              "Visit our online store to save up to 80% on eTextbooks from VitalSource!"
            )}
          </p>
          <Button
            href={`/#/redirect/${encodeURIComponent(storeUrl)}?sso=true`}
            target="_blank"
          >
            {t("global-bar.shop-now")}
          </Button>
        </BottomContentTextBlocks>
      </ActionBlock>
    );
  }
};

const renderRedeemBlock = redeem => {
  if (Fraction.Brand.Menu.redeem) {
    return (
      <ActionBlock className="null-redeem-block">
        <SvgContainer>
          <RedeemCodes />
        </SvgContainer>
        <BottomContentTextBlocks>
          <h3>{t("redeem.redeem-codes", "Redeem Codes")}</h3>
          <p>
            {t(
              "library.instant-books",
              "Redeem book codes to instantly add books to your library."
            )}
          </p>
          <Button onClick={redeem}>{t("redeem.redeem", "Redeem")}</Button>
        </BottomContentTextBlocks>
      </ActionBlock>
    );
  }
};

function ActionBlocks({ openRedeemModal, goToStore }) {
  return (
    <BottomContent>
      {renderRedeemBlock(openRedeemModal)}
      {renderShopBlock(goToStore)}
    </BottomContent>
  );
}

const mapDispatchToProps = dispatch => ({
  openRedeemModal: () => dispatch(modalActions.openRedeemModal()),
  goToStore: () => dispatch(goToStore())
});

export default connect(null, mapDispatchToProps)(ActionBlocks);
